import AnalysisResource from '@/resources/AnalysisResource';

export default class Analysis {
    constructor() {
        this.Resource = new AnalysisResource()
    }

    async getFunnelReport (page, startDate, endDate, websiteId = null) {
        const transactions = await this.Resource.getFunnelReport(page, startDate, endDate, websiteId)

        return transactions.data
    }

    async exportFunnelReport (format, startDate, endDate, websiteId = null) {
        return await this.Resource.exportFunnelReport(format, startDate, endDate, websiteId)
    }

    async getFunnelReportItem (transactionId) {
        const reportItem = await this.Resource.getFunnelReportItem(transactionId)

        return reportItem.data
    }

    async requestPageReport (startDate, endDate, websiteId) {
        const report = await this.Resource.requestPageReport(startDate, endDate, websiteId)

        return report.data
    }

    async listPageReports () {
        const report = await this.Resource.listPageReports()

        return report.data
    }

    async getPageReport (id) {
        const report = await this.Resource.getPageReport(id)

        return report.data
    }
}
